import axios from 'axios'
import i18n from './../plugins/i18n'

export default {
  // Загрузка виджета по позиции
  loadWidgetByPosition (position) {
    return axios.get(`${i18n.locale}/api/public/cms/widget/${position}`)
  },
  // Загрузка блога по ссылке
  loadBlogBySlug (slug, limit = 0) {
    return axios.get(`${i18n.locale}/api/public/cms/blog/${slug}/${limit}`)
  },
  // Загрузка блоков
  loadBlocks () {
    return axios.get(`${i18n.locale}/api/public/cms/widgetBlocks`)
  },
  // Загрузка страницы по ссылке
  loadPageBySlug (slug) {
    return axios.get(`${i18n.locale}/api/public/cms/article/${slug}`)
  }
}
